import { render, staticRenderFns } from "./WarningCard.vue?vue&type=template&id=0a7800ee&scoped=true&"
import script from "./WarningCard.vue?vue&type=script&lang=ts&"
export * from "./WarningCard.vue?vue&type=script&lang=ts&"
import style0 from "./WarningCard.vue?vue&type=style&index=0&id=0a7800ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7800ee",
  null
  
)

export default component.exports